module.exports = __webpack_public_path__ + "img/n-tuijian.3dd2f36f.svg";